module.exports = __webpack_public_path__ + "static/media/arab21.32a123de.wav";